import * as d3 from 'd3';
import { createContext, PropsWithChildren, useContext, useEffect } from 'react';
import { BehaviorSubject } from 'rxjs';
import { CanvasContext } from './CanvasProvider';
import { ZoomContext } from './ZoomProvider';

// Intentionally rxjs: mouse position updates fire on every mousemove and are
// consumed by Link's d3 subscription which updates SVG directly, bypassing
// React renders. Replacing with useState/atoms would trigger React renders on
// every mousemove and tank performance.
const mousePosition$ = new BehaviorSubject<[number, number]>([0, 0]);

const providerValue = { mousePosition$ };

export const MouseContext = createContext(providerValue);

export const MouseContextProvider = ({ children }: PropsWithChildren) => {
  const { zoomElement } = useContext(ZoomContext);
  const { svg } = useContext(CanvasContext);

  useEffect(() => {
    if (!zoomElement?.current || !svg) {
      return;
    }
    // Namespace the handler so SelectionArea's mousemove (or any future listener)
    // doesn't overwrite it. d3 keys handlers by `event.namespace`.
    svg.on('mousemove.mouseTracking', (event) => {
      const [x, y] = d3.pointer(event, zoomElement?.current);
      mousePosition$.next([x, y]);
    });
  }, [zoomElement, svg]);

  return <MouseContext.Provider value={providerValue}>{children}</MouseContext.Provider>;
};
